import * as dailyMain from './daily-main.js';
import * as medicine from './medicine.js';

export default {
    dailyMain,
    medicine,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Daily Main
    window.EQLAPP.DAILY = window.EQLAPP.DAILY || {};
    Object.entries(dailyMain).forEach(([key, value]) => {
        window.EQLAPP.DAILY[key] = value;
    });

    // Billing Centre
    window.EQLAPP.MEDICINE = window.EQLAPP.MEDICINE || {};
    Object.entries(medicine).forEach(([key, value]) => {
        window.EQLAPP.MEDICINE[key] = value;
    });

}